import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-premier-purple to-premier-pink flex items-center justify-center">
      <div className="bg-white p-8 m-8 rounded-lg shadow-lg text-center">
        <h1 className="text-4xl font-bold mb-4 text-premier-purple">404 - Page Not Found</h1>
        <p className="text-gray-700 mb-6">
          Oops! The page you're looking for doesn't exist.
        </p>
        <Link
          to="/match-predictor"
          className="bg-premier-purple text-white px-6 py-3 rounded-full hover:bg-premier-pink transition duration-300 ease-in-out"
        >
          Go Back
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;